import React, { memo } from "react";
import { withNamespaces } from "react-i18next";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { RiRobotLine } from "react-icons/ri";

const LiaAiConfirmationModal = ({
  t,
  isOpen,
  toggle,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>{t("Generate LIA?")}</ModalHeader>

      <ModalBody>
        <div className="text-center">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
            style={{
              width: 72,
              height: 72,
              background: "rgba(13, 110, 253, 0.1)",
            }}
          >
            <RiRobotLine size={36} className="text-primary" />
          </div>

          <h5 className="mb-3">{t("Generate LIA")}</h5>

          <p className="text-muted mb-0">
            {t(
              "Would you like to generate the LIA Assessment using AI?"
            )}
          </p>

          <small className="text-muted d-block mt-3">
            {t(
              "AI will analyze the case and fill the LIA fields. Please review the generated content and save the workflow."
            )}
          </small>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={isLoading}>
          {t("Cancel")}
        </Button>

        <Button color="primary" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? t("Generating...") : t("Generate with AI")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default withNamespaces()(memo(LiaAiConfirmationModal));
